export default __webpack_public_path__ + "static/media/void2.b4456c0f.svg";